































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "precisionmarketing/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "信息类别", scopedSlots: { customRender: "type" } },
    { title: "对象来源", scopedSlots: { customRender: "user_type" } },
    { title: "简要营销内容", scopedSlots: { customRender: "content" } },
    { title: "时间", dataIndex: "created_time" },
    { title: "通知人数", dataIndex: "user_count" }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;
  
  mounted() {
    this.loadData();
  }
}
